"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as DS from 'D5Utils/operation_widget/datasources';
import { System } from "Constants/objects";

var OperationTypeWidget =
/*#__PURE__*/
function () {
  function OperationTypeWidget(_ref) {
    var type = _ref.type,
        id = _ref.id,
        operation = _ref.operation,
        _ref$subscribers = _ref.subscribers,
        subscribers = _ref$subscribers === void 0 ? [] : _ref$subscribers;

    _classCallCheck(this, OperationTypeWidget);

    _defineProperty(this, "_type", '');

    _defineProperty(this, "_operation", '');

    _defineProperty(this, "_subscribers", []);

    _defineProperty(this, "$button", null);

    this._type = type;

    if (this._type === System.FIELD_EDITOR_TYPE.BOOL_SB || this._type === System.FIELD_EDITOR_TYPE.SELECT || this._type === System.FIELD_EDITOR_TYPE.MULTI_SELECT || this._type === System.FIELD_EDITOR_TYPE.BOOL_CB) {
      return;
    }

    this._operation = operation || this._getDefaultOperation();
    this._subscribers = subscribers;
    this.$button = $("<div id=\"operation-type-widget-".concat(id, "\"/>"));
    this.render();
  }

  _createClass(OperationTypeWidget, [{
    key: "_getDefaultOperation",
    value: function _getDefaultOperation() {
      switch (this._type) {
        case 'string':
          return 'contains';

        default:
          return '=';
      }
    }
  }, {
    key: "createDS",
    value: function createDS() {
      var _this = this;

      var ds = this._getDataSource();

      var root = ds.find(function (item) {
        return item.symbol === _this._operation;
      });

      if (root) {
        root = _objectSpread({}, root);
        root.items = [];
        root.text = '';
        root.selected = true;
        ds.forEach(function (item) {
          if (item.id !== root.id) {
            var tItem = _objectSpread({}, item);

            tItem.items = [];
            root.items.push(_objectSpread({}, tItem));
          }
        });
        return [root];
      }

      return [];
    }
  }, {
    key: "_getDataSource",
    value: function _getDataSource() {
      switch (this._type) {
        case System.FIELD_EDITOR_TYPE.TEXT:
        case System.FIELD_EDITOR_TYPE.NUMBER:
        case System.FIELD_EDITOR_TYPE.DATE:
          return DS["".concat(this._type, "_DS")];

        case 'datetime':
          return DS['date_DS'];

        default:
          return [];
      }
    }
  }, {
    key: "onItemClick",
    value: function onItemClick(e) {
      this.operation(e);
    }
  }, {
    key: "itemTemplate",
    value: function itemTemplate(itemData) {
      var result = $("<div>").addClass('operation-type-widget-li');
      $("<div>").addClass("".concat(itemData.icon)).appendTo(result);
      $("<div>").text(itemData.text).appendTo(result);
      return result;
    }
  }, {
    key: "element",
    value: function element() {
      return this.$button;
    }
  }, {
    key: "operation",
    value: function operation() {
      var _this2 = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          itemData = _ref2.itemData;

      if (this._type === System.FIELD_EDITOR_TYPE.BOOL_SB || this._type === System.FIELD_EDITOR_TYPE.SELECT || this._type === System.FIELD_EDITOR_TYPE.MULTI_SELECT || this._type === System.FIELD_EDITOR_TYPE.BOOL_CB) {
        return '=';
      }

      if (!itemData || itemData.symbol == null || itemData.symbol === this._operation) return this._operation;
      this._operation = itemData.symbol;

      this._subscribers.forEach(function (s) {
        if (typeof s.onOperationChanged === 'function') s.onOperationChanged(_this2._operation);
      });

      this.$button.dxMenu("dispose");
      this.render();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      this.$button = this.$button && this.$button.dxMenu({
        dataSource: this.createDS(),
        itemTemplate: this.itemTemplate,
        onItemClick: function onItemClick(e) {
          return _this3.onItemClick(e);
        },
        selectionMode: "single",
        width: 24,
        height: 24,
        activeStateEnabled: false,
        elementAttr: {
          'class': "operation-type-widget"
        }
      });
    }
  }]);

  return OperationTypeWidget;
}();

export { OperationTypeWidget as default };